import styles from "./styles.module.css";
import i18n from "../producers/i18n";
import jwt_decode from "jwt-decode";

export const Header: view = ({
  updateLangId = update.langId,
  langMenuOpen = observe.langMenuOpen,
  languageChoice = observe.languageChoice,
  updateLoggedOut = update.loggedOut,
  updateLangMenuOpen = update.langMenuOpen,
  updateLanguageChoice = update.languageChoice,
  jwtToken = observe.jwtToken
}) => {
  const identity = jwtToken ? jwt_decode(jwtToken) : {};
  const displayName = (identity.telephone && identity.telephone !== 'undefined') ? identity.telephone : `${identity.given_name} ${identity.family_name}`
  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <h2 className={styles.heading}>
          {jwtToken
            ? `${i18n.t("header.dashboard")} - ${displayName}`
            : i18n.t("header.dashboard")
          }
        </h2>
      </div>
      <div className="relative">
        <button className="flex items-center p-2 rounded-md text-lg"
          onClick={() => updateLangMenuOpen.set(!langMenuOpen)}>
          <span className="mr-2 text-lg text-white">{languageChoice} </span>
          <svg className="w-6 h-6 text-white text-gray-800" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path>
          </svg>
        </button>
        <div className={langMenuOpen ? "absolute right-0 py-2 mt-2 bg-white bg-gray-100 rounded-md shadow-xl w-44" : "hidden absolute right-0 py-2 mt-2 bg-white bg-gray-100 rounded-md shadow-xl w-44"}>
          <div className="block px-4 py-2 text-md text-gray-300 text-gray-700 hover:bg-gray-400 cursor-pointer"
            onClick={() => {
              i18n
                .changeLanguage("sv-SE")
                .then(() => {
                  updateLangId.set("sv-SE");
                  updateLanguageChoice.set("SE")
                  updateLangMenuOpen.set(false);
                });
            }}
          >
            {i18n.t("languages.swedish")}
          </div>
          <div className="block px-4 py-2 text-md text-gray-300 text-gray-700 hover:bg-gray-400 cursor-pointer"
            onClick={() => {
              i18n
                .changeLanguage("en-US")
                .then((t) => {
                  updateLangId.set("en-US");
                  updateLanguageChoice.set("EN")
                  updateLangMenuOpen.set(false);
                });
            }}
          >
            {i18n.t("languages.english")}
          </div>
          {/* <div className="block px-4 py-2 text-md text-gray-300 text-gray-700 hover:bg-gray-400 cursor-pointer"
            onClick={() => {
              updateLangId.set("nb-NO");
              updateLanguageChoice.set("NO")
              i18n
                .changeLanguage("nb-NO")
                .then((t) => {
                  updateLangMenuOpen.set(false);
                });
            }}
          >
            {i18n.t("languages.norwegian")}
          </div> */}
        </div>
      </div>
      {jwtToken && <div className="relative">
        <button className="flex items-center p-2 rounded-md text-lg"
          onClick={() => {
            console.log("LOGOUT");
            updateLoggedOut.set(true);
          }}>
          <svg className="w-6 h-6 text-white text-gray-800" xmlns="http://www.w3.org/2000/svg" width="20" height="30" viewBox="0 0 20 20" fill="#FFF">
            <title>
              {i18n.t("header.logout")}
            </title>
            <path d="M3 3h8V1H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8v-2H3z" />
            <path d="M19 10l-6-5v4H5v2h8v4l6-5z" />
          </svg>
        </button>
      </div>}
    </div >
  );
};
